import styles from './SmartApplyPage.module.scss'
import { SmartApplyPartner } from '@percent/cause-dashboard/constants/smartApplyPartners'
import { SmartApplyPartnerLogos } from '../../explicitSmartApply/smartApplyPartnerLogos/SmartApplyPartnerLogos'
import { SmartApplyVariantRouter } from '../../explicitSmartApply/SmartApplyVariantRouter'
import { POSTHOG_FEATURE_FLAGS, usePostHogFeatureFlag } from '@percent/cause-dashboard/common/hooks'

type SmartApplyPageProps = {
  hasCanvaApplication: boolean
  secondaryAction?: () => void
  pagesVisible: boolean
  pagesCount: number
  page: number
  height: number
  width: number
  setSelectedPartner: (partner: SmartApplyPartner | null) => void
  appliedPartners: Set<SmartApplyPartner>
  registerDismissCallback?: (callback: (() => void) | null) => void
}

export function SmartApplyPage({
  hasCanvaApplication,
  secondaryAction,
  pagesVisible,
  pagesCount,
  page,
  height,
  width,
  setSelectedPartner,
  appliedPartners,
  registerDismissCallback
}: Readonly<SmartApplyPageProps>) {
  const areDynamicLogosEnabled = usePostHogFeatureFlag(POSTHOG_FEATURE_FLAGS.CP_SMART_APPLY_DYNAMIC_LOGOS)

  return (
    <div className={styles.modalCtn} style={{ height, width: '100%', maxWidth: width }}>
      <div className={`${styles.column} ${styles.leftColumn}`}>
        <div className={`${styles.leftCtn} ${!pagesVisible ? styles.lessPadding : ''}`}>
          <SmartApplyVariantRouter
            setSelectedPartner={setSelectedPartner}
            appliedPartners={appliedPartners}
            onClose={() => setSelectedPartner(null)}
            secondaryAction={secondaryAction}
            hasCanvaApplication={hasCanvaApplication}
            page={page}
            pagesCount={pagesCount}
            registerDismissCallback={registerDismissCallback}
          />
        </div>
      </div>
      {areDynamicLogosEnabled ? (
        <div className={`${styles.column} ${styles.rightVariantColumn}`}>
          <SmartApplyPartnerLogos />
        </div>
      ) : (
        <div className={`${styles.column} ${styles.rightColumn}`} />
      )}
    </div>
  )
}
